export default __webpack_public_path__ + "static/media/Mark-3-HUD-06.cbe7c9b8.jpg";